import React from 'react';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { DomainTypeGq } from '../../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { ProjectSettingsMenuChoices } from '../../ProjectSettingsPage/ProjectSettingsPage';
import { ProjectTabChoices } from '../ProjectPage';
import GotToEditLink from './GotToEditLink';


export interface ProjectDomainIndicatorProps {
  project: ProjectGq;
}

export const ProjectDomainIndicator: React.FC<ProjectDomainIndicatorProps> = ({ project }) => {
  const domain = project.domains.find((d) => d.type === DomainTypeGq.PROJECT);
  const projectDomainString = domain ? domain.hostName : 'no domain';
  const settingsUrl = `/${project.id}/${ProjectTabChoices.Settings}/${ProjectSettingsMenuChoices.General}#domain`;

  return (
    <VoxelTooltipShort message={!domain ? 'Add project domain' : 'Edit project domain'}>
      <GotToEditLink href={settingsUrl} className="h-7" hasError={!domain}>
        <span className="truncate hidden md:inline md:max-w-[140px] lg:max-w-[300px] xl:max-w-[380px] 2xl:max-w-[420px]">
          {projectDomainString}
        </span>
      </GotToEditLink>
    </VoxelTooltipShort>
  );
};

export default ProjectDomainIndicator;
